import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';

const POSITIONS = {
  [cardProviders.MONAVATE]: {
    x: 170,
    y: 157,
  },
};
export const PinLabel = ({ isVisible, cardProvider = null }) => {
  if (!isVisible) return null;

  const { x = 170, y = 157, width = 45, height = 15 } = POSITIONS[cardProvider] || {};
  return (
    <svg
      x={x}
      y={y}
      width={width}
      height={height}
      viewBox="0 0 45 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.46555 0.656708C3.52657 0.656708 4.3128 1.3895 4.3128 2.3742C4.3128 3.35125 3.52657 4.07642 2.46555 4.07642H1.31292V6H0.534329V0.656708H2.46555ZM1.31292 3.37415H2.58768C3.22887 3.37415 3.45787 3.15279 3.45787 2.54213V2.191C3.45787 1.58033 3.22887 1.35897 2.58768 1.35897H1.31292V3.37415ZM5.18764 5.31301H6.47767V1.3437H5.18764V0.656708H8.54628V1.3437H7.25626V5.31301H8.54628V6H5.18764V5.31301ZM9.62723 0.656708H10.8409L12.4515 5.12981H12.5508L12.4973 0.656708H13.2607V6H12.047L10.4287 1.5269H10.3295L10.3906 6H9.62723V0.656708Z"
        fill="#2D2926"
      />
    </svg>
  );
};

PinLabel.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  cardProvider: PropTypes.string,
};

export default PinLabel;
